import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  rootContainer: css`
    margin: auto;
    background: ${COLORS.GRAY};
  `,
  container: css`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
  section: css`
    width: 100%;
  `,
  mainContent: css`
    padding: 40px 48px 100px;
  `
};

export default styles;
